export default __webpack_public_path__ + "static/ui-transfers-b53db863889119a972cf9a2912bad226.png";